import { Component } from '@angular/core';
import { ModalController, ViewController } from 'ionic-angular';
import { LoginPage,HomePage } from "../../pages/dashboard";
/**
 * Generated class for the ForbidenloginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modals-component',
  templateUrl: 'cmp.html'
})
export class ModalsComponent {

  text: string;

  constructor(
    public viewCtrl : ViewController,
  ) {
  }

  goMenu(menu){
    this.viewCtrl.dismiss(menu);
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/cmp.ts